import { BaseModel } from 'paliari-js-utils'
import DocTexto from './DocTexto'

const attributes = {
  id: null,
  tipo: '',
  unidade: '',
  titulo: '',
  read_only: false,
  valor: 0,
}

class DocValor extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default DocValor
